import { CategoryWithTimesplit } from '~/interfaces/Category';
import { timesplitIcons } from '~/routes/schedule.templates';

export default function TimesplitFilters({
  availableTimesplits,
  onClickTimesplit,
  tagFilters,
  templateCategories,
  timesplitFilters,
}: {
  availableTimesplits: Set<string>;
  onClickTimesplit: (timesplit: string) => void;
  tagFilters: string[];
  templateCategories: CategoryWithTimesplit[];
  timesplitFilters: string[];
}) {
  return (
    <>
      <h5 className="text-xs font-bold uppercase text-brown">Select a time split</h5>
      <ul className="flex flex-wrap items-center justify-center gap-[10px]">
        {templateCategories.map((category) => {
          const filterLabel = category.name.substring(0, 5);
          const filterIcon = timesplitIcons[filterLabel];
          const isSelected = timesplitFilters.includes(category.timesplitName);
          const isDisabled = tagFilters.length ? !availableTimesplits.has(category.timesplitName) : false;

          return (
            <li
              key={category.name}
              className={`bg-beige-pale ${isSelected ? 'border-green-primary-text' : 'border-taupe-light'} rounded-3xl border text-sm font-bold text-green-primary-text`}
            >
              <button
                className={`flex items-center justify-center gap-x-1 px-2 py-[3px] ${isDisabled ? 'cursor-not-allowed opacity-50' : ''}`}
                disabled={isDisabled}
                onClick={() => onClickTimesplit(filterLabel.replace('/', '-'))}
              >
                {filterIcon}
                {filterLabel}
              </button>
            </li>
          );
        })}
      </ul>
    </>
  );
}
